module.exports = __webpack_public_path__ + "bin/img/about_visual.babc7e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_visual.jpg
// module id = U2M4
// module chunks = 1